import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../common/GetProxy";
import { handleResponseCode } from "../../../../app/utilities/helpers";
const proxy = GetProxy();
const cookies = new Cookies();

export const cloudAccountList = createAsyncThunk(
  "post/cloudAccountList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { appliaction, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/CSPForAws/CspAccountListWithPaginationAndSearching/${appliaction}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const cloudAccountCount = createAsyncThunk(
  "post/cloudAccountCount",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { application, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/CSPForAws/CspAccountListWithPaginationAndSearching/${application}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const userAccountList = createAsyncThunk(
  "post/userAccountList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { cmdb, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/UserAccessRest/usersListByIdSearchAndPagination/${cmdb}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const userAccountCount = createAsyncThunk(
  "post/userAccountCount",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { cmdb, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/UserAccessRest/usersListByIdSearchAndCount/${cmdb}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const deviceList = createAsyncThunk("post/DeviceList", async (props) => {
  const Apitoken = cookies.get("apitoken");
  const User = cookies.get("username");
  try {
    const { cmdbId, pageNumber, itemsPerPage, payload } = props;
    const response = await fetch(
      `${proxy}/api/v1/server/list/searchAndPagination/${cmdbId}/${pageNumber}/${itemsPerPage}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    );
    handleResponseCode(response);
    const data = await response.json();

    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});

export const deviceCount = createAsyncThunk(
  "post/deviceCount",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { cmdbId, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/server/list/searchAndCount/${cmdbId}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const projectList = createAsyncThunk(
  "post/projectList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { id, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/cmdb/${id}/projectsSearchAndPagination/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const projectCount = createAsyncThunk(
  "post/projectCount",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { id, payload } = props;
      const response = await fetch(`${proxy}/api/v1/cmdb/${id}/projectsSearchCount`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const userdrilldownList = createAsyncThunk(
  "post/userdrilldownList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { accountId, pageNumber, itemsPerPage, payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/awsIam/getUsersForAccountListWithPaginationAndSearch/${accountId}/${pageNumber}/${itemsPerPage}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const userdrilldownCount = createAsyncThunk(
  "post/userdrilldownCount",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { accountId, payload } = props;
      const response = await fetch(`${proxy}/api/v1/awsIam/getUsersForAccountListWithPaginationAndSearchCount/${accountId}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getCSPList = createAsyncThunk(
  "get/getCSPList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const response = await fetch(
      `${proxy}/api/v1/awsIam/getCSPList`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    )
    handleResponseCode(response);
    const data = await response.json();

    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
  }
);
export const getAccountIdList = createAsyncThunk(
  "get/getAccountIdList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
    const CSP = props;
    const response = await fetch(
      `${proxy}/api/v1/awsIam/getAccountIdList/${CSP}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    )     
    handleResponseCode(response);
    const data = await response.json();

    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
  }
);
export const CmdbList = createAsyncThunk(
  "post/CmdbList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { page, limit , payload } = props;
      const response = await fetch(`${proxy}/api/v1/cmdb/cmdbListSearchAndPagination/${page}/${limit}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const CmdbCount = createAsyncThunk(
  "post/CmdbCount",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(`${proxy}/api/v1/cmdb/cmdbListSearchCount`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const getEnvironmentList = createAsyncThunk(
  "get/getEnvironmentList",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
    const response = await fetch(
      `${proxy}/api/v1/environmentDropDown/criticalityByType`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
      }
    );
    handleResponseCode(response);
    const data = await response.json();
    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error in getting environment:", error);
    throw error;
  }
}
);
export const getApplication = createAsyncThunk(
  "get/getApplication",
  async () => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
    const response = await fetch(
      `${proxy}/api/v1/Landing/getApplications/${username}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": apiToken,
          USERNAME: username,
        },
      }
    );
    handleResponseCode(response);
    const data = await response.json();
    return response.ok ? data : Promise.reject(data)
  } catch (error) {
    console.error("Error:", error);
    throw error;
    }
});
export const getApplicationDetails = createAsyncThunk(
  "get/getApplicationDetails",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
    const appCode = props;
    const response = await fetch(
      `${proxy}/api/v1/Landing/getApplicationDetails`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body : JSON.stringify({
          appCode : appCode,
        })
      }
    )     
    handleResponseCode(response);
    const data = await response.json();

    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
  }
);
const appConfigSlice = createSlice({
  name: "appConfig",
  initialState: {
    applicationList:[],
    appLoader:false,
    appInfo:[],
    appInfoLoader:false,
    cloudAccountListLoading: false,
    cloudAccountListData: [],
    cloudAccountCountLoading: false,
    cloudAccountCountData: [],
    userAccountCountData: [],
    userAccountCountLoading: false,
    userAccountListData: [],
    userAccountListLoading: false,
    deviceListData: [],
    CmdbListData:[],
    CmdbListLoading: false,
    CmdbCountLoading: false,
    CmdbCountData:[],
    deviceCountData: [],
    deviceCountLoading: false,
    deviceListLoading: false,
    projectListData: [],
    projectCountData: [],
    projectCountLoading: false,
    projectListLoading: false,
    userdrilldownData:[],
    userdrilldownLoading:false,
    userdrilldownCountData:[],
    userdrilldownCountLoading:false,
    getCSPListData:[],
    getCSPListLoading:false,
    getAccountIdListData:[],
    getAccountIdListLoading:false,
    EnvironmentData : [],
    EnvironmentLoading : false,
    error:false,
  },
  reducers: {
    setAlertError: (state, action) => {
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cloudAccountList.pending, (state, action) => {
        state.cloudAccountListLoading = true;
        state.error = false;
      })
      .addCase(cloudAccountList.fulfilled, (state, action) => {
        state.cloudAccountListData = action.payload;
        state.cloudAccountListLoading = false;
        state.error = false;
      })
      .addCase(cloudAccountList.rejected, (state, action) => {
        state.cloudAccountListLoading = false;
        state.cloudAccountListData = [];
        state.error = true;
      })

      .addCase(getApplication.pending, (state, action) => {
        state.appLoader = true;
        state.applicationList = [];
        state.error = false;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        state.appLoader = false;
        state.applicationList = action.payload;
        state.error = false;
      })
      .addCase(getApplication.rejected, (state, action) => {
        state.appLoader = false;
        state.error = true;
      })  

      .addCase(getApplicationDetails.pending, (state, action) => {
        state.appInfoLoader = true;
        state.appInfo = [];
        state.error = false;
      })
      .addCase(getApplicationDetails.fulfilled, (state, action) => {
        state.appInfoLoader = false;
        state.appInfo = action.payload;
        state.error = false;
      })
      .addCase(getApplicationDetails.rejected, (state, action) => {
        state.appInfoLoader = false;
        state.error = true;
      })  

      .addCase(cloudAccountCount.pending, (state, action) => {
        state.cloudAccountCountLoading = true;
        state.error = false;
      })
      .addCase(cloudAccountCount.fulfilled, (state, action) => {
        state.cloudAccountCountData = action.payload;
        state.cloudAccountCountLoading = false;
        state.error = false;
      })
      .addCase(cloudAccountCount.rejected, (state, action) => {
        state.cloudAccountCountLoading = false;
        state.cloudAccountCountData = [];
        state.error = true;
      })
      .addCase(userAccountList.pending, (state, action) => {
        state.userAccountListLoading = true;
        state.error = false;
      })
      .addCase(userAccountList.fulfilled, (state, action) => {
        state.userAccountListData = action.payload;
        state.userAccountListLoading = false;
        state.error = false;
      })
      .addCase(userAccountList.rejected, (state, action) => {
        state.userAccountListLoading = false;
        state.userAccountListData = [];
        state.error = true;
      })

      .addCase(userAccountCount.pending, (state, action) => {
        state.userAccountCountLoading = true;
        state.error = false;
      })
      .addCase(userAccountCount.fulfilled, (state, action) => {
        state.userAccountCountData = action.payload;
        state.userAccountCountLoading = false;
        state.error = false;
      })
      .addCase(userAccountCount.rejected, (state, action) => {
        state.userAccountCountLoading = false;
        state.userAccountCountData = [];
        state.error = true;
      })
      .addCase(deviceList.pending, (state, action) => {
        state.deviceListLoading = true;
        state.error = false;
      })
      .addCase(deviceList.fulfilled, (state, action) => {
        state.deviceListData = action.payload;
        state.deviceListLoading = false;
        state.error = false;
      })
      .addCase(deviceList.rejected, (state, action) => {
        state.deviceListLoading = false;
        state.deviceListData = [];
        state.error = true;
      })

      .addCase(deviceCount.pending, (state, action) => {
        state.deviceCountLoading = true;
        state.error = false;
      })
      .addCase(deviceCount.fulfilled, (state, action) => {
        state.deviceCountData = action.payload;
        state.deviceCountLoading = false;
        state.error = false;
      })
      .addCase(deviceCount.rejected, (state, action) => {
        state.deviceCountLoading = false;
        state.deviceCountData = [];
        state.error = true;
      })
      .addCase(projectList.pending, (state, action) => {
        state.projectListLoading = true;
        state.error = false;
      })
      .addCase(projectList.fulfilled, (state, action) => {
        state.projectListData = action.payload;
        state.projectListLoading = false;
        state.error = false;
      })
      .addCase(projectList.rejected, (state, action) => {
        state.projectListLoading = false;
        state.projectListData = [];
        state.error = true;
      })

      .addCase(projectCount.pending, (state, action) => {
        state.projectCountLoading = true;
        state.error = false;
      })
      .addCase(projectCount.fulfilled, (state, action) => {
        state.projectCountData = action.payload;
        state.projectCountLoading = false;
        state.error = false;
      })
      .addCase(projectCount.rejected, (state, action) => {
        state.projectCountLoading = false;
        state.projectCountData = [];
        state.error = true;
      })
      .addCase(userdrilldownList.pending, (state, action) => {
        state.userdrilldownLoading = true;
        state.error = false;
      })
      .addCase(userdrilldownList.fulfilled, (state, action) => {
        state.userdrilldownData = action.payload;
        state.userdrilldownLoading = false;
        state.error = false;
      })
      .addCase(userdrilldownList.rejected, (state, action) => {
        state.userdrilldownLoading = false;
        state.userdrilldownData = [];
        state.error = true;
      })

      .addCase(userdrilldownCount.pending, (state, action) => {
        state.userdrilldownCountLoading = true;
        state.error = false;
      })
      .addCase(userdrilldownCount.fulfilled, (state, action) => {
        state.userdrilldownCountData = action.payload;
        state.userdrilldownCountLoading = false;
        state.error = false;
      })
      .addCase(userdrilldownCount.rejected, (state, action) => {
        state.userdrilldownCountLoading = false;
        state.userdrilldownCountData = [];
        state.error = true;
      })

      .addCase(getCSPList.pending, (state, action) => {
        state.getCSPListLoading = true;
        state.error = false;
      })
      .addCase(getCSPList.fulfilled, (state, action) => {
        state.getCSPListData = action.payload;
        state.getCSPListLoading = false;
        state.error = false;
      })
      .addCase(getCSPList.rejected, (state, action) => {
        state.getCSPListLoading = false;
        state.getCSPListData = [];
        state.error = true;
      })
      .addCase(getAccountIdList.pending, (state, action) => {
        state.getAccountIdListLoading = true;
        state.error = false;
      })
      .addCase(getAccountIdList.fulfilled, (state, action) => {
        state.getAccountIdListData = action.payload;
        state.getAccountIdListLoading = false;
        state.error = false;
      })
      .addCase(getAccountIdList.rejected, (state, action) => {
        state.getAccountIdListLoading = false;
        state.getAccountIdListData = [];
        state.error = true;
      })
      .addCase(CmdbList.pending, (state, action) => {
        state.CmdbListLoading = true;
        state.error = false;
      })
      .addCase(CmdbList.fulfilled, (state, action) => {
        state.CmdbListData = action.payload;
        state.CmdbListLoading = false;
        state.error = false;
      })
      .addCase(CmdbList.rejected, (state, action) => {
        state.CmdbListLoading = false;
        state.CmdbListData = [];
        state.error = true;
      })
      .addCase(CmdbCount.pending, (state, action) => {
        state.CmdbCountLoading = true;
        state.error = false;
      })
      .addCase(CmdbCount.fulfilled, (state, action) => {
        state.CmdbCountData = action.payload;
        state.CmdbCountLoading = false;
        state.error = false;
      })
      .addCase(CmdbCount.rejected, (state, action) => {
        state.CmdbCountLoading = false;
        state.CmdbCountData = [];
        state.error = true;
      })

      .addCase(getEnvironmentList.pending, (state, action) => {
        state.EnvironmentLoading = true;
        state.error = false;
      })
      .addCase(getEnvironmentList.fulfilled, (state, action) => {
        state.EnvironmentData = action.payload;
        state.EnvironmentLoading = false;
        state.error = false;
      })
      .addCase(getEnvironmentList.rejected, (state, action) => {
        state.EnvironmentLoading = false;
        state.EnvironmentData = [];
        state.error = true;
      })
  },
});
export const {setAlertError} = appConfigSlice.actions;
export default appConfigSlice.reducer;
